import { EstadoConciliacionType } from "api/Types/EstadoConciliacion"
import { UUIDType } from "uuid"

export const CONCILIACION_CONCILIAR_MOVIMIENTOS_COMMAND_DTO = {
  AMORTIZACION_IDS: "amortizacionIds",
  DEVOLUCION_IDS: "devolucionIds",
  ESTADO_FACTURA_UNICA: "estadoFacturaUnica",
  FACTURA_IDS: "facturaIds",
  FLUJO_TESORERIA_IDS: "flujoTesoreriaIds",
  ID_EXTERNO: "idExterno",
} as const

export interface ConciliacionConciliarMovimientosCommandDtoProps {
  amortizacionIds?: UUIDType[] | string[] | null
  devolucionIds?: UUIDType[] | string[] | null
  estadoFacturaUnica?: EstadoConciliacionType
  facturaIds?: UUIDType[] | string[] | null
  asientosIds?: UUIDType[] | string[] | null
  flujoTesoreriaIds?: UUIDType[] | string[] | null
  idExterno?: UUIDType | string
}
